import config from '../config';
import * as actions from '../actions/employees';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';
import { path } from "ramda";
import moment from 'moment';
import {loadWorkerOrderNumbers} from "../actions/employees";

export function fetchAllEmployees() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl('employee')
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(actions.loadAllEmployees({
              list: json.employees,
              fields: json.fields_options
            }));
          }
        })
        .catch(response => dispatch(actions.loadAllEmployeesFailed({ error: response })));
    }
  }
};

function sort(list, compareFn) {
  if (list && compareFn) {
    return list.sort(compareFn);
  }
}

export function fetchEmployee(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`employee/${id}`)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            // sort by date_from desc
            json.vacations = sort(json.vacations, (x, y) => (moment(x.date_from) - moment(y.date_from)) >= 0 ? -1 : 1);
            // sort by date desc
            json.bonuses = sort(json.bonuses, (x, y) => (moment(x.date) - moment(y.date)) >= 0 ? -1 : 1);
            // sort by date desc
            json.past_raises = sort(json.past_raises, (x, y) => (moment(x.date) - moment(y.date)) >= 0 ? -1 : 1);

            dispatch(actions.loadEmployee({ currentEmployee: json }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Get Employee',
            message: 'Failed to get employee',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function saveEmployeesFieldSettings(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl('employee/saveFieldOptions', 'POST', data)
        .then((response) => {
          if (!response.ok) {
            throw 'Error. Status code ' + response.status;
          }
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(actions.updateEmployeesFields({
              fields: data
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Field settings',
            message: 'Failed to save field settings',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function addEmployee(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl('employee', 'POST', data)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          const errors = path(['detail'], json);
          if (errors) {
            dispatch(actions.saveEmployeesFailed({
              errors: errors
            }));
            dispatch(notify({
              title: 'Add New Employee',
              message: 'Failed to add employee. Please review errors below',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          } else if (json) {
            dispatch(actions.saveEmployeesFailed({
              errors: undefined
            }));
            dispatch(push('/pages/employees'));
            dispatch(notify({
              title: 'Add New Employee',
              message: 'Employee added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Employee',
            message: 'Failed to add employee',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function updateEmployee(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`employee/${id}`, 'PUT', data)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          const errors = path(['detail'], json);
          if (errors) {
            dispatch(actions.saveEmployeesFailed({
              errors: errors
            }));
            dispatch(notify({
              title: 'Update Employee',
              message: 'Failed to update employee. Please review errors below',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          } else if (json) {
            dispatch(actions.saveEmployeesFailed({
              errors: undefined
            }));

            dispatch(notify({
              title: 'Update Employee',
              message: 'Employee updated successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Update Employee',
            message: 'Failed to update employee',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function deleteEmployee(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`employee/${data.id}`, 'DELETE')
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(actions.deleteEmployee({ id: data.id }));
            dispatch(notify({
              title: 'Delete Employee',
              message: 'Employee deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

export function getEmployeePdf(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`employee/printInPdf/${id}`)
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([blob], {type: "application/pdf"})

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          window.open(data);

          setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            //window.URL.revokeObjectURL(data);
          }, 100);
        })
        .catch(response => {
          dispatch(notify({
            title: 'PDF Download',
            message: 'Failed to download PDF',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getHistory(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`taskHistory/${id}/3`)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(actions.loadEmployeeHistory({
              employeeHistory: json,
            }));
          }
        })
    }
  }
};

export function fetchWorkers(workOrderNumber) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      const url = new URL(`${config.apiEndpoint}/workers`);
      if (workOrderNumber) {
        const params = {
          'workOrderNumber': workOrderNumber
        }
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

      }
      return fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(data => {
          if (data) {
            dispatch(actions.loadSingleWorker({ workers: data }));
          }
        })
    }
  }
};

export function fetchWorkOrderNumbers() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/workers/work-order-numbers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(data => {
          if (data) {
            dispatch(actions.loadWorkOrderNumbers({ workOrderNumbers: data }));
          }
        })
    }
  }
}

export function fetchWorker(workerId) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/workers/${workerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(data => {
          if (data) {
            dispatch(actions.loadWorkers({ worker: data }));
          }
        })
    }
  }
};

const fetchUrl = (url, method = 'GET', data) => {
  return fetch(`${config.apiEndpoint}/${url}`, {
    method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `bearer ${store.get('user').api_token}`
    },
    credentials: 'same-origin'
  })
};

export function format_ss_no (employee_ss_no) {
  return (employee_ss_no || '')
    .toString()
    .padEnd(9)
    .replace(/^([0-9 ]{3})([0-9 ]{2})([0-9 ]{4}).*/,"$1-$2-$3");
}



// WEBPACK FOOTER //
// ./src/api/employees.js